import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { State } from '../../types/state'
import PlantCard from './components/PlantCard'
import Pagination from './components/Pagination'
import { usePlantFilters } from './hooks/usePlantFilters'
import { usePlantSearch } from './hooks/usePlantSearch'
import { plantOptions } from './data/plantOptions'
import AppNavBar from '../Header/AppNavBar'
import InlineFilters from './components/InlineFilters'

const PlantSearch: React.FC = () => {
  const navigate = useNavigate()
  const { isSuperadmin } = useSelector((state: State) => state.user)
  const [searchTerm, setSearchTerm] = useState('')

  // Hooki filtrów i wyszukiwania
  const {
    filters,
    expandedFilters,
    toggleFilter,
    handleFilterChange,
    handleNumericFilterChange,
    clearAllFilters
  } = usePlantFilters(plantOptions, setSearchTerm)

  const {
    filteredPlants,
    currentPage,
    totalPages,
    totalPlants,
    pageSize,
    handlePageChange,
    handleItemsPerPageChange,
    isValidUrl
  } = usePlantSearch(filters, searchTerm)

  // Przekierowanie do szczegółów rośliny
  const handlePlantClick = (id: number) => {
    navigate(`/plants/${id}`)
  }

  return (
    <>
      <AppNavBar
        rightIcons={[]}
      />
      <section className='plant-search pt-60 pb-60'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12 col-md-12 col-lg-12'>
              <div className='heading mb-40 text-center md:text-left'>
                <div className='tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-between tw-gap-4'>
                  <div className='tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-4'>
                    {isSuperadmin && (
                      <button
                        className={`
                          tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                          tw-text-white
                          tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                        `}
                        onClick={() => navigate('/plants/add')}
                      >
                        <i className='fas fa-plus mr-2' /> Dodaj nową roślinę
                      </button>
                    )}
                    <button
                      className={`
                        tw-text-center tw-font-semibold tw-rounded-md tw-shadow-lg tw-transition-colors
                        tw-text-teal
                        tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-white hover:tw-bg-opacity-90 focus:tw-bg-white
                      `}
                      onClick={() => navigate('/plants/advanced-search')}
                    >
                      <i className='fas fa-search-plus mr-2' /> Wyszukiwanie zaawansowane
                    </button>
                  </div>
                  <InlineFilters
                    filterOptions={plantOptions}
                    filters={filters}
                    expandedFilters={expandedFilters}
                    toggleFilter={toggleFilter}
                    handleFilterChange={handleFilterChange}
                    handleNumericFilterChange={handleNumericFilterChange}
                    clearAllFilters={clearAllFilters}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            {/* Wyniki wyszukiwania */}
            <div className='col-lg-12'>
              <div className='plant-results'>
                {filteredPlants.length === 0
                  ? (
                    <div className='text-center py-5'>
                      <i className='fas fa-leaf fa-3x text-muted mb-3' />
                      <h4>Nie znaleziono roślin</h4>
                      <p>Spróbuj zmienić kryteria wyszukiwania.</p>
                    </div>
                    )
                  : (
                    <div>
                      <div className='plant-counter text-center mb-4'>
                        <h5 className='m-0'>Znaleziono <span className='text-primary'>{totalPlants}</span> roślin</h5>
                      </div>

                      <div className='row'>
                        {filteredPlants.map(plant => (
                          <div key={plant.id} className='col-sm-6 col-md-4 col-lg-4 mb-30'>
                            <PlantCard
                              plant={plant}
                              onClick={handlePlantClick}
                              isValidUrl={isValidUrl}
                            />
                          </div>
                        ))}
                      </div>

                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalItems={totalPlants}
                        pageSize={pageSize}
                        onPageChange={handlePageChange}
                        onItemsPerPageChange={handleItemsPerPageChange}
                      />
                    </div>
                    )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default PlantSearch
